var $ = jQuery;

var counter = 0;

function Accordion(opts) {
	var settings = {
		$container:null,
		titleSelector:'> li > .accordion--title',
		contentSelector:'> li > .accordion--content',
		contentOpenedClass:'accordion--content__open'
	};
	
	$.extend(settings,opts);
	
	var _this = this;
	
	this._counter = counter++;
	this._namespace = "accordion" + this._counter;
	this._$titles = null;
	this._$contents = null;
	this._onClick = function(e) {
		e.preventDefault();
		var idx = _this._$titles.index($(this));
		_this.open(idx);
	};
	
	this._contentHeight = 0;
	this._activeIndex = null;
	this.settings = settings;
}

Accordion.prototype = {
	open:function(idx){
		if (this._activeIndex !== idx) {
			this._activeIndex = idx;
			var $content = this._$contents.eq(idx);
			var $title = this._$titles.eq(idx);
			this._$contents.css('height','0').removeClass(this.settings.contentOpenedClass);
			$content.css('height', this._contentHeight + 'px').addClass(this.settings.contentOpenedClass);
			if (this.settings.titleOpenedClass) {
				this._$titles.removeClass(this.settings.titleOpenedClass);
				$title.addClass(this.settings.titleOpenedClass);
			}
			this.onOpenCallback && this.onOpenCallback(idx);
		}
	},
	init:function(){
		this.destroy();
		this._$titles = this.settings.$container.find(this.settings.titleSelector);
		this._$contents = this.settings.$container.find(this.settings.contentSelector);
		var height = 0;
		this._$titles.each(function(){
			height += $(this).outerHeight(true);
		});
		var maxHeight = this.settings.$container.height();
		this._contentHeight = maxHeight - height;
		this.settings.$container.on(
			'click.' + this._namespace,
			this.settings.titleSelector,
			this._onClick
		);
	},
	destroy:function(){
		this._$titles = null;
		this._$contents = null;
		this._contentHeight = 0;
		this.settings.$container.off('.' + this._namespace);
	}
};

module.exports = Accordion;